import styled from "styled-components";

export const InfomationLookGood = styled.div`
	background: #2c76aa;
	display: flex;
	justify-content: space-between;
	padding: 14px;
	font-size: 1rem;
	border-radius: 10px;
	color: #ffffff;
	width: 100%;
	margin: 0 auto;

	.gr-button {
		display: flex;
		align-items: center;
		gap: 20px;
		button {
			font-size: 1rem;
			color: #ffffff;
			text-decoration: underline;
		}
	}

	@media only screen and (max-width: 768px) {
		font-size: 0.875rem;
		display: flex;
		flex-direction: column;
		.gr-button {
			display: flex;
			align-items: center;
			gap: 20px;
			padding-top: 5px;
			justify-content: end;
			button {
				font-size: 0.875rem;
				color: #ffffff;
				text-decoration: underline;
			}
		}
	}
`;

/**
 * Will remove after checking on Monday
 * - Background body all page
 */
export const ProfileContainer = styled.div<{ isMobileScreen: boolean }>`
	// background-color: rgb(228 228 228);
	// min-height: 100vh;
	margin-top: ${({ isMobileScreen }) =>
		isMobileScreen ? `70px;` : `10px`};
`;
export const Container = styled.div`
	@media only screen and (min-width: 768px) and (max-width: 1024px) {
		width: 100%;
	}

	background-color: rgb(245 245 245);
	width: 100%;
	background-color: rgb(228 228 228);

	&.back-container {
		display: flex;
		justify-content: space-between;
	}
	.edit-icon {
	}
	.header-button {
		button {
			/* color: #58585b !important; */
			div:last-child {
				/* border-bottom: 1px solid #58585b !important; */
				border-bottom: none
			}
		}
	}
	.card-firm-profile {
		.header-button {
			button {
				/* color: #58585b !important; */
				div:last-child {
					border-bottom: 1px solid #58585b !important;
				}
			}
		}
	}
	.NavActive {
		border-bottom: 2px solid rgb(250 0 27);
	}
	@media only screen and (min-width: 1025px) {
		max-width: 1142px;
		margin: 10px auto;
		width: 90%;
		gap: 10px;
		display: flex;
		.edit-header-btn {
			display: flex;
			justify-content: flex-end;
			padding-right: 25px;
			padding-top: 10px;
			z-index: 999;
		}
		.card-firm-profile {
			width: 70%;
			height: fit-content;
			display: flex;
			flex-direction: column;
			// gap: 10px;

			& > div {
				margin-bottom: 10px;
			}
		}
		.card-backgound {
			background-color: white;
			border-radius: 10px;
		}
		.add-service {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.add-description {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.serviceBtn p{
			color: #0971a2;
			size: 12px;
			font-weight: 400;
			line-height: 14.06px;
			&:hover {
				cursor: pointer;
				color: white;
			}
		}
		.serviceBtn svg{
			margin-top: auto 0;
		}
		.serviceBtn {
			gap: 5px !important;
			text-align: center!important;
			border-radius: 20px !important;
			height: 34px !important;
			border: 1px solid #0971a2 !important;
			padding: 10px 20px !important;
			margin-bottom: 15px !important;
			background-color: #ffffff !important;
			display: flex !important;
			@media only screen and (min-width: 769px) {
				&:hover {
				cursor: pointer;
					background-color: #0971a2 !important;
					color: white;
					p {
						color: white;
					}
				}
			}

		}
		.card-add-service {
		}
		.card-left-profile {
			display: flex;
			flex-direction: column;
			gap: 10px;
			width: 30%;
			height: fit-content;
			background-color: transparent;
			border-radius: 10px;
		}
		.card-firm-item {
			height: 140px;
			width: calc(100% - 20px);
			background-color: white;
			margin: 10px 0;
			border-radius: 10px;
		}
		.edit-logo {
		position: absolute;
		display: flex;
		/* right: 5px;
		top: 5px; */
		bottom: 97px;
    	left: 97px;
		z-index: 99221 !important;
	}
	}
	@media only screen and (min-width: 769px) and (max-width: 1024px) {
		max-width: 1142px;
		margin: 20px auto;
		width: 90%;
		display: flex;
		.card-firm-profile {
			width: 70%;
			margin: 0px 10px 0 0;
			height: fit-content;
			gap: 10px;
			display: flex;
			flex-direction: column;
		}
		.card-backgound {
			background-color: white;
			border-radius: 10px;
		}
		.edit-header-btn {
			display: flex;
			justify-content: flex-end;
			padding-right: 25px;
			padding-top: 10px;
		}
		.add-service {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.add-description {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.card-add-service {
		}
		.card-left-profile {
			width: 30%;
			height: fit-content;
			background-color: transparent;
			border-radius: 10px;
			gap: 10px;
			display: flex;
			flex-direction: column;
		}
		.card-firm-item {
			height: 140px;
			width: calc(100% - 20px);
			background-color: white;
			margin: 10px 10px;
			border-radius: 10px;
		}
		.edit-logo {
		position: absolute;
		display: flex;
		/* right: 5px;
		top: 5px; */
		bottom: 97px;
    	left: 97px;
		z-index: 99221 !important;
		}
		.serviceBtn p{
			color: #0971a2;
			size: 12px;
			font-weight: 400;
			line-height: 14.06px;
			&:hover {
				cursor: pointer;
				color: white;
			}
		}
		.serviceBtn svg{
			margin-top: auto 0;
		}
		.serviceBtn {
			gap: 5px !important;
			text-align: center!important;
			border-radius: 20px !important;
			height: 34px !important;
			border: 1px solid #0971a2 !important;
			padding: 10px 20px !important;
			margin-bottom: 15px !important;
			background-color: #ffffff !important;
			display: flex !important;
			&:hover {
			cursor: pointer;
				background-color: #0971a2 !important;
				color: white;
				p {
					color: white;
				}
			}
		}
	}
	@media only screen and (min-width: 641px) and (max-width: 768px) {
		max-width: 1142px;
		padding: 10px 0;
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 10px;
		margin: 0 auto;
		.container {
			height: 100%;
			max-width: 700px;
			display: flex;
		}
		.edit-header-btn {
			display: flex;
			justify-content: flex-end;
			padding-right: 25px;
			padding-top: 10px;
		}
		&.back-container {
			display: flex;
			justify-content: space-between;
		}
		.edit-icon {
			display: flex;
			justify-content: flex-end;
		}
		.card-firm-profile {
			width: 100%;
			height: fit-content;
			gap: 10px;
			display: flex;
			flex-direction: column;
		}
		.card-backgound {
			background-color: white;
			border-radius: 10px;
		}
		.add-service {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.add-description {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.card-add-service {
			// margin: 0px 10px;
		}
		.card-left-profile {
			width: 100%;
			height: fit-content;
			background-color: transparent;
			border-radius: 10px;
			gap: 10px;
			display: flex;
			flex-direction: column;
		}
		.card-firm-item {
			height: 140px;
			width: 100%;
			background-color: white;
			margin: 10px 0px;
			border-radius: 10px;
		}
		.serviceBtn p{
			color: #0971a2;
			size: 12px;
			font-weight: 400;
			line-height: 14.06px;
			&:hover {
				cursor: pointer;
				color: white;
			}
		}
		.serviceBtn svg{
			margin-top: auto 0;
		}
		.serviceBtn {
			gap: 5px !important;
			text-align: center!important;
			border-radius: 20px !important;
			height: 34px !important;
			border: 1px solid #0971a2 !important;
			padding: 10px 20px !important;
			margin-bottom: 15px !important;
			background-color: #ffffff !important;
			display: flex !important;
			@media only screen and (min-width: 769px) {

			&:hover {
			cursor: pointer;
				background-color: #0971a2 !important;
				color: white;
				p {
					color: white;
				}
			}
			}
		}
	}
	@media only screen and (max-width: 640px) {
		max-width: 1142px;
		padding: 10px 0;
		width: 100%;
		gap: 10px;
		display: flex;
		flex-direction: column;
		margin: 0 auto;
		.container {
			height: 100%;
			max-width: 700px;
		}
		.card-firm-profile {
			width: 100%;
			height: fit-content;
			gap: 10px;
			display: flex;
			flex-direction: column;
		}
		.card-backgound {
			background-color: white;
			border-radius: 10px;
		}
		.edit-header-btn {
			display: flex;
			justify-content: flex-end;
			padding-right: 25px;
			padding-top: 10px;
		}
		.edit-icon {
			display: flex;
			justify-content: flex-end;
		}
		.add-service {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.add-description {
			border-radius: 10px;
			width: 100%;
			height: fit-content;
		}
		.card-add-service {
			// margin: 0px 5px;
		}
		.card-left-profile {
			width: 100%;
			height: fit-content;
			background-color: transparent;
			border-radius: 10px;
			gap: 10px;
			display: flex;
			flex-direction: column;
		}
		.card-firm-item {
			height: 140px;
			width: 100%;
			background-color: white;
			margin: 10px 0px;
			border-radius: 10px;
		}
		.mobile-header-distance {
			padding: 0 5px;
		}
		.mobile-content-distance {
			margin-left: -5px;
			padding: 0px 10px 0 10px;
		}
		/* .mobile-content-distance .check-box-lable {
			font-size: 0.6875rem !important;
		} */
		.mobile-content-distance .description {
			padding-left: 0px;
			padding-right: 0px;
		}
		.serviceBtn p{
			color: #0971a2;
			size: 12px;
			font-weight: 400;
			line-height: 14.06px;
			&:hover {
				cursor: pointer;
				color: white;
			}
		}
		.serviceBtn svg{
			margin-top: auto 0;
		}
		.serviceBtn {
			gap: 5px !important;
			text-align: center!important;
			border-radius: 20px !important;
			height: 34px !important;
			border: 1px solid #0971a2 !important;
			padding: 10px 20px !important;
			margin-bottom: 15px !important;
			background-color: #ffffff !important;
			display: flex !important;
			@media only screen and (min-width: 769px) {

			&:hover {
			cursor: pointer;
				background-color: #0971a2 !important;
				color: white;
				p {
					color: white;
				}
			}
			}
		}
	}
`;

export const Logo = styled.div<{ bg?: string }>`
	background-image: url(${(p) => p?.bg});
	background-position: center center;
	background-repeat: no-repeat;
	height: 100%;
	transition: transform 0.5s ease 0s;
	background-color: white;
	background-size: contain;
	width: 100%;
	background-position: center;
`;

export const FirmBackGound = styled.div`
	border-radius: 10px;
	.card-firm-info h2 {
		cursor: pointer;
	}

	@media only screen and (min-width: 1025px) {
		.card-firm-info h2 {
			font-size: 2rem;
			font-weight: 500;
		}
		.card-firm-backgound {
			height: 205px;
		}
		.card-logo {
			width: 103px;
			height: 103px;
		}
		.card-service-logo {
			width: 103px;
			height: 103px;
		}
	}

	@media only screen and (min-width: 769px) and (max-width: 1024px) {
		.card-firm-info h2 {
			font-size: 2rem;
			font-weight: 500;
		}
		.card-firm-backgound {
			height: 205px;
		}
		.card-logo {
			width: 103px;
			height: 103px;
		}
		.card-service-logo {
			width: 103px;
			height: 103px;
		}
	}

	@media only screen and (min-width: 501px) and (max-width: 768px) {
		.card-firm-info{
			margin-top: 15px;
		}
		.card-firm-info h2 {
			font-size: 1.625rem;
			font-weight: 500;
		}
		.card-firm-backgound {
			height: 74px;
		}
		.card-logo {
			width: 70px;
			height: 70px;
			bottom: -20px !important;
		}
		.card-service-logo {
			width: 70px;
			height: 70px;
		}
		.edit-logo {
			position: absolute;
			display: flex;
			bottom: 33px;
			left: 69px;
			z-index: 99221 !important;
		}
	}

	@media only screen and (max-width: 500px) {
		.card-firm-info{
			margin-top: 15px;
		}
		.card-firm-info h2 {
			font-size: 1.625rem;
			font-weight: 500;
		}
		.card-firm-backgound {
			height: 74px;
		}
		.card-logo {
			width: 70px;
			height: 70px;
			bottom: -20px !important;
		}
		.card-service-logo {
			width: 70px;
			height: 70px;
		}
		.edit-logo {
			position: absolute;
			display: flex;
			bottom: 33px;
			left: 69px;
			z-index: 99221 !important;
		}
	}

	.card-firm-backgound {
		background-color: rgb(183 192 197);
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		text-align: center;
		background-size: contain;
		background-repeat: no-repeat;
		position: relative;
		background-position: center;
		background-size: cover;
	}

	.card-logo {
		margin-top: -135px;
		margin-left: 20px;
		background-color: transparent;
		position: absolute;
		bottom: 20px;
		border-radius: 50%; 
		overflow: hidden;
	}

	.backgound {
		width: 100%;
	}

	.backgound img {
		width: 100%;
		height: 250px;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		border-color: #999;
	}

	.card-firm-bottom {
		height: 100%;
	}

	.card-firm-info {
		padding: 0px 20px 0 20px;
	}

	.firm-tagline {
		font-size: 1rem;
		font-weight: 400;
	}
	.firm-url {
		gap: 10px;
		margin: 20px 0px
	}
	.firm-url-info {
		font-size: 0.875rem;
		font-weight: 700;
		text-decoration: underline;
		cursor: pointer;
		color: #333333;
		display: block;
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.url-icon {
		margin: 5px 0px;
	}
	.back-icon{
	}

	.firm-location {
		color: #999;
		font-size: 0.875rem;
	}

	.add-service-content {
		display: flex;
	}

	.add-service-content-main {
		display: flex;
	}

	.nav-page {
		display: inline-flex;
		height: 56px;
		width: 100%;
		border-top: 1px solid #EAEAEA;
		padding: 0px 20px;

	}

	.nav-list::-webkit-scrollbar {
    	display: none;
	}

	.nav-list {
		list-style: none;
		display: flex;
		gap: 20px;
		overflow-x: auto;
		-ms-overflow-style: none;
		scrollbar-width: none;
	}

	.nav-list li {
		display: flex;
	}

	.nav-list-item {
		text-decoration: none;
		color: #333333;
		font-size: 0.875rem;
		font-weight: 700; 
		line-height: 16.41px;
		border-radius: 5px;
		padding: 20px 20px;
		transition: background-color 0.3s ease;
	}

	@media only screen and (min-width: 769px) {
		.nav-list-item:hover {
		border-bottom: 4px solid rgb(9 113 161);
		border-radius: 0.5px;
		color: #0971a2;
		cursor: pointer;
		}
	}

	.NavItemActive {
		font-weight: bold;
		color: #0971a2;
		background-color: none;
		border-bottom: 4px solid rgb(9 113 161);
		border-radius: 0.5px;
		color: #0971a2;	}
`;

export const Div = styled.div``;

export const FirmContactBrochureAttach = styled.div`
	width: 20%;
	.contact {
		padding: 15px;
	}
	.contact-title {
		width: 100%;
		display: flex;
	}
	.contact-title h2 {
		font-size: 1.125rem;
		font-weight: 800;
		flex: 1;
	}
	.contact-title {
		margin: 10px 0px;
	}
	.contact-add {
		display: flex;
		margin: 10px 0px;
	}
	.contact-add h2 {
		color: rgba(9, 113, 162, 1);
		text-decoration: underline;
		padding-left: 5px;
		font-weight: 700;
	}
`;
export const FirmAddServices = styled.div`
	height: 100px;
	width: 80%;
	background-color: #fff;
	.btn-service {
		flex: 1;
	}
	.lable-service {
		display: inline-flex;
	}
	.lable-service img {
		width: 17px;
		height: auto;
	}
	.lable-service h2 {
		margin: auto;
		color: rgba(9, 113, 162, 1);
		padding-left: 5px;
		text-decoration: underline;
	}
	.add-service-btn {
		display: flex;
		background-color: rgb(44 118 170);
		color: white;
		font-weight: 200;
	}
	.add-service-btn img {
		margin: auto;
		padding-left: 5px;
	}
`;

export const FirmAddDesciption = styled.div`
	height: 100px;
	width: 80%;
	background-color: #fff;
	display: block;
	.add-desc {
		padding: 20px;
	}
	.card-add-des-title {
		display: flex;
		padding: 10px;
	}
	.card-add-des-title h2 {
		flex: 1;
		font-size: 1.125rem;
		font-weight: 700;
	}
	.card-add-des-title img {
		width: 17px;
	}
	.card-add-des-btm {
		display: flex;
		padding: 10px;
	}
	.card-add-des-btm img {
		width: 17px;
	}
	.card-add-des-btm h2 {
		text-decoration: underline;
		color: rgba(9, 113, 162, 1);
		padding-left: 10px;
		font-size: 0.9375rem;
	}
`;

export const PenIconStyled = styled.svg`
	&:hover {
		cursor: pointer;
	}
`;

export const ServiceList = styled.div`
	height: 100px;
	width: 80%;
	background-color: #fff;
	display: block;
	.add-desc {
		padding: 20px;
	}
	.card-add-des-title {
		display: flex;
		padding: 10px;
	}
	.card-add-des-title h2 {
		flex: 1;
		font-size: 1.125rem;
		font-weight: 700;
	}
	.card-add-des-title img {
		width: 17px;
	}
	.card-add-des-btm {
		display: flex;
		padding: 10px;
	}
	.card-add-des-btm img {
		width: 17px;
	}
	.card-add-des-btm h2 {
		text-decoration: underline;
		color: rgba(9, 113, 162, 1);
		padding-left: 10px;
		font-size: 0.9375rem;
	}
`;

export const ProductList = styled.div`
	height: 100px;
	width: 80%;
	background-color: #fff;
	display: block;
	.add-desc {
		padding: 20px;
	}
	.card-add-des-title {
		display: flex;
		padding: 10px;
	}
	.card-add-des-title h2 {
		flex: 1;
		font-size: 1.125rem;
		font-weight: 700;
	}
	.card-add-des-title img {
		width: 17px;
	}
	.card-add-des-btm {
		display: flex;
		padding: 10px;
	}
	.card-add-des-btm img {
		width: 17px;
	}
	.card-add-des-btm h2 {
		text-decoration: underline;
		color: rgba(9, 113, 162, 1);
		padding-left: 10px;
		font-size: 0.9375rem;
	}
`;
export const TagSponsorService = styled.span`
	background: #0971A2;
	border-radius: 5px;
	font-size: 11px;
	padding: 3px 10px;
	font-weight: bold;
	color: #FFFFFF;
	width: 85px;
	height: 22px;
	display: flex;
`;

export const TagVendor = styled.span`
	font-size: 11px;
	padding: 3px 10px;
	font-weight: bold;
	height: 22px;
	line-height: 12.89px;
`;

export const RejectMessage = styled.polygon`
	color: red;
`;